<template>
    <div
        v-if="resolvedBrands.length"
        class="hover:cursor-pointer"
        :class="{ 'w-14 h-14': size === 'md' }"
        tabindex="0"
        @click="toggleModal('brand')"
        @keydown.enter="toggleModal('brand')"
    >
        <template v-for="(brand, index) in resolvedBrands" :key="index">
            <MiscImage
                :lazy-load="true"
                :alt="brand.alt"
                :title="brand.alt"
                :src="brand.src"
                fit="fit"
                :class="{
                    'w-14 max-h-14': size === 'md',
                    'h-[72px] w-auto': size === 'lg'
                }"
            />
        </template>
    </div>
</template>

<script setup lang="ts">
const { toggleModal } = useModal()

const props = defineProps<{
    brands?: string,
    size?: 'md' | 'lg',
    alt?: string,
}>()

const brandMap: Record<string, { srcs: string[], alt: string }> = {
    E: { srcs: ['/images/brands/small/lebe-gesund.png'], alt: props.alt || 'Lebe Gesund' },
    Z: { srcs: ['/images/brands/small/zukauf.png'], alt: props.alt || 'Zukauf' },
    A: { srcs: ['/images/brands/small/annoni.png'], alt: props.alt || 'Annoni' },
    T: { srcs: ['/images/brands/small/lebe-gesund-hp.png'], alt: props.alt || 'Lebe Gesund' },
    X: { srcs: ['/images/brands/small/no-brand.png'], alt: props.alt || 'No Brand' },
    I: {
        srcs: [
            '/images/brands/small/in-den-spuren-der-natur.png',
            '/images/brands/small/bestes-guenstig.png'
        ],
        alt: props.alt || 'In den Spuren der Natur'
    }
}

const resolvedBrands = computed(() => {
    const brandKeys = props.brands ? props.brands.split(',').map(b => b.trim().toUpperCase()).filter(Boolean) : ['E']

    return brandKeys
        .filter(b => brandMap[b]).flatMap(b => {
            const entry = brandMap[b]
            return entry.srcs.map(src => ({
                src,
                alt: entry.alt
            }))
        })
})
</script>
